import {spawnErrorToast} from '@hm/fundamental'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {
  QueryKeyName,
  assignTopicResponsible,
  assignSectionResponsible,
  assignPlantResponsible
} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'
import {usePlantUpmId} from '../usePlantUpmIdContext'

interface UseAssignResponsibleArgs {
  userId: string
  plantId?: string
  sectionId?: string
  topicId?: string
}

export const useAssignResponsible = (onSuccess?: () => void) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const plantId = usePlantUpmId()
  const client = useQueryClient()
  return useMutation({
    mutationFn: ({sectionId, userId, topicId}: UseAssignResponsibleArgs) =>
      topicId
        ? assignTopicResponsible({plantId, topicId, userId})
        : sectionId
          ? assignSectionResponsible({plantId, sectionId, userId})
          : assignPlantResponsible({plantId, userId}),
    onSuccess: () => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetPlant]})
      void client.invalidateQueries({queryKey: [QueryKeyName.GetSection]})
      void client.invalidateQueries({queryKey: [QueryKeyName.GetTopic]})
      onSuccess?.()
    },
    onError: () => {
      spawnErrorToast(t('assignResponsible.afterSubmit.error'))
    }
  })
}
